import type { FC } from 'react';
import { Button } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';
import { georgeStats } from '@shared/statistics';

import type { ActivePAPIProductWithAvatarData } from '../types';
import { useDashboardAppearanceChange } from './hooks/useDashboardAppearanceChange';
import { useActivePAPIProduct } from '../../../ActivePAPIProductContext';

export const DashboardAppearanceChange: FC = () => {
    const {
        _embedded: {
            customization: { hiddenOnOverview },
        },
    } = useActivePAPIProduct<ActivePAPIProductWithAvatarData>();

    const { hideAccountOnOverview, showAccountOnOverview } = useDashboardAppearanceChange();

    const showAccountAndTrack = () => {
        georgeStats.trackEvent('productSettings', 'showAccountOnOverviewIconClicked');
        showAccountOnOverview();
    };

    const hideAccountAndTrack = () => {
        georgeStats.trackEvent('productSettings', 'hideAccountOnOverviewIconClicked');
        hideAccountOnOverview();
    };

    if (hiddenOnOverview === undefined) {
        return null;
    }

    if (hiddenOnOverview) {
        return (
            <Button
                className="g-inverted"
                icon={Button.ICON.SHOW_ON}
                size={Button.SIZE.SMALL}
                data-cy="account-settings-personalise-show-on-overview-button"
                onClick={showAccountAndTrack}
            >
                {t('app.showOverview')}
            </Button>
        );
    }

    return (
        <Button
            className="g-inverted"
            icon={Button.ICON.SHOW_OFF}
            size={Button.SIZE.SMALL}
            data-cy="account-settings-personalise-hide-on-overview-button"
            onClick={hideAccountAndTrack}
        >
            {t('app.hideOverview')}
        </Button>
    );
};
